import { render, staticRenderFns } from "./WalletTestbed.vue?vue&type=template&id=9195ca38&scoped=true"
import script from "./WalletTestbed.vue?vue&type=script&lang=js"
export * from "./WalletTestbed.vue?vue&type=script&lang=js"
import style0 from "./WalletTestbed.vue?vue&type=style&index=0&id=9195ca38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9195ca38",
  null
  
)

export default component.exports